import cloneDeep from 'lodash/cloneDeep';

import store from 'Redux/store';

const PRODUCTS_GROUP_AGGREGATE = 'frontend/product/PRODUCTS_GROUP_AGGREGATE';

const YT_VIDEO_BROKEN = 'frontend/products/YT_VIDEO_BROKEN';


export function ytVideoBroken(video) {
  return store.dispatch({ type: YT_VIDEO_BROKEN, payload: video });
}

export function sendProductAggregate(product) {
  const gtmFilteredProduct = cloneDeep(product);
  delete gtmFilteredProduct.blogPosts;
  delete gtmFilteredProduct.streams;
  delete gtmFilteredProduct.videos;
  delete gtmFilteredProduct.desc;
  delete gtmFilteredProduct.regions_excluded;
  delete gtmFilteredProduct.regions_included;
  delete gtmFilteredProduct.img;
  delete gtmFilteredProduct.reviews;
  delete gtmFilteredProduct.editions;
  delete gtmFilteredProduct.notice;

  store.dispatch({ type: PRODUCTS_GROUP_AGGREGATE, payload: gtmFilteredProduct });
}
